// Redux
import { configureStore } from "@reduxjs/toolkit";

import multiboardReducer, { MultiboardState } from "../features/multiboard/multiboardSlice";
import { loadSessionState, saveSessionState, throttle } from "./persistSession";

const SESSION_KEY = "jupiter:redux";

export interface PersistedRootState {
  multiboard: MultiboardState;
}

const preloadedState = loadSessionState<PersistedRootState>(SESSION_KEY);

export const store = configureStore({
  reducer: {
    multiboard: multiboardReducer,
  },
  preloadedState,
  devTools: process.env.NODE_ENV !== "production",
});

store.subscribe(
  throttle(() => {
    const state = store.getState();
    const toPersist: PersistedRootState = {
  multiboard: {
    ...state.multiboard,
    saved: state.multiboard.saved,
  },
};

    saveSessionState(SESSION_KEY, toPersist);
  }, 300)
);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;